import { ADD_PRODUCTS_PAGE, COPY_PRODUCTS_PAGE } from '../actions/catalogue';
import productsPageReducer from './productsPage';

export const initialState = {
  productsPagesByRoute: {}, // TODO add cache invalidation!!
};

export default function catalogue(state = initialState, action) {
  switch (action.type) {
    case ADD_PRODUCTS_PAGE: {
      // action = { type, route, productsPage }
      const productsPagesByRoute = Object.keys(state.productsPagesByRoute).includes(action.route) ?
        {
          ...state.productsPagesByRoute,
        } :
        {
          ...state.productsPagesByRoute,
          [action.route]: action.productsPage,
        };
      return { ...state, productsPagesByRoute };
    }
    case COPY_PRODUCTS_PAGE: {
      const productsPagesByRoute = {
        ...state.productsPagesByRoute,
        [action.routeTo]: state.productsPagesByRoute[action.routeFrom],
      };
      return { ...state, productsPagesByRoute };
    }
    default:
      // TODO maybe we should also check some action prefixes? e.g. introduce redux-ducks?
      if (action.route) {
        // action = { type, route, ...anything }
        // generic handler for all catalogue's productPage modifications, pass to dedicated reducer
        const productsPage = state.productsPagesByRoute[action.route];
        if (productsPage) {
          const newProductsPage = productsPageReducer(productsPage, action);
          if (productsPage !== newProductsPage) {
            // make sure the sub-reducer actually changed the productsPage
            const productsPagesByRoute = { ...state.productsPagesByRoute, [action.route]: newProductsPage };
            return { ...state, productsPagesByRoute };
          }
        }
      }

      return state;
  }
}
